import { BsDatabaseFillDown } from "react-icons/bs";
import { FaChartPie } from "react-icons/fa";

const DataMasuk = ({
  total,
  bulan,
  name,
  icon,
  totalAtensi,
  isAtensi = false,
}) => {
  return (
    <div className="flex flex-col gap-2 rounded-[10px] bg-gradient-to-b from-gray-800 to-teal-800 p-4">
      {/* Header */}
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <BsDatabaseFillDown size={20} color="white" />

          <h4 className="text-sm font-bold text-white">
            {bulan}
          </h4>
        </div>
        <span className="text-body-sm font-medium text-gray-300">{name}</span>


        {!isAtensi && (
          <span className="rounded-full bg-white p-1">
            {icon}
          </span>
        )}
      </div>

      {/* Content */}
      <div className="flex items-end justify-between gap-3">
        <div>
          <p className="text-[10px] font-medium text-gray-300">
            {isAtensi ? "Total Data" : name}
          </p>

          <h4 className="text-2xl font-bold text-white">
            {Intl.NumberFormat("id-ID").format(total || 0)}
          </h4>
        </div>

        {isAtensi && (
          <div className="text-right">
            <p className="text-[10px] font-medium text-gray-300">
              Total Atensi
            </p>

            <div className="flex items-center justify-end gap-1">
              <FaChartPie
                size={14}
                className="text-white"
              />

              <h4 className="text-2xl font-bold text-white">
                {Intl.NumberFormat("id-ID").format(
                  totalAtensi || 0
                )}
              </h4>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DataMasuk;